<template>
    <div>
        <InfoPageBlock
            h1="Let’s get your trademark registration to the finish line."
            stepsLength="7"
            url="/statement-of-use/confirm"
        ></InfoPageBlock>
    </div>
</template>

<script>
import InfoPageBlock from '@/components/blocks/InfoPageBlock.vue'
import {to_top} from "@/helper";

export default {
    components: {
        InfoPageBlock
    },
    mounted() {
        to_top()
        this.$store.commit('header/setTotal', 0)
    }
}
</script>
